import type { BoundFormatMoney } from "~/modules/multi-currency/ui/format-money";

export const reportDollarsToCents = (value: number | null | undefined): number => {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return 0;
  }
  return Math.round(value * 100);
};

export const formatReportDollarAmount = (value: number | null | undefined, formatMoney: BoundFormatMoney, precision = 2): string =>
  formatMoney(reportDollarsToCents(value), { precision, minimumPrecision: precision });
